export default __webpack_public_path__ + "static/media/hero_9.bcffeca5.png";